import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form'
import useAxios from 'axios-hooks'
import DeleteModal from '../../DeleteModal/DeleteModal'
import { AlertService } from '../../../services/AlertService'

const AddUserCard = ({ selectedUser, onAdd,executeGet }) => {
  const { t } = useTranslation()
  const { register, handleSubmit, formState, reset, watch, setValue } = useForm(
    {
      mode: 'onChange',
    }
  )
  const values = watch()
  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [deleteModalEndpoint, setDeleteModalEndpoint] = useState('')

  useEffect(() => {
    setValue('firstName', selectedUser ? selectedUser.first_name : '')
    setValue('lastName', selectedUser ? selectedUser.last_name : '')
    setValue('emailAddress', selectedUser ? selectedUser.email_address : '')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedUser])

  const [{ error, loading }, executePost] = useAxios(
    {
      url: `${process.env.REACT_APP_BASE_URL}api/v1/users${selectedUser ? `/${selectedUser.id}` : ''
        }`,
      method: 'POST',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('jwt')}`,
      },
    },
    {
      manual: true,
    }
  )
  const [{ resError, resLoading }, exeRestore] = useAxios(
    {
      url: `${process.env.REACT_APP_BASE_URL}api/v1/users/restore`,
      method: 'POST',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('jwt')}`,
      },
    },

    {
      manual: true,
    }
  )

  const handleInputChange = e => {
    setValue(e.target.name, e.target.value)
  }

  const handleUserDelete = () => {
    setOpenDeleteModal(true)
    setDeleteModalEndpoint(
      `${process.env.REACT_APP_BASE_URL}api/v1/users/${selectedUser.id}`
    )
  }

  const handleAddUser = async () => {
    try {
      let response = await executePost({
        params: {
          ...values,
        },
      });
      AlertService.showSuccess(t('SAVE_SUCCESS'));
    } catch (e) {
      // Handle cancellation
      
      switch (e.response.data.code) {
        case 'USER_ALREADY_EXISTS':
          AlertService.showError(t('STUDENT_EMAIL_EXISTS'));
          break;
        case "USER_DELETED":
          let restoreData = await exeRestore({
            params: {
              emailAddress: selectedUser ? selectedUser.email_address : values.emailAddress,
            },
          });
          if (restoreData.status == 200) {
            executeGet();
            AlertService.showSuccess(t('SAVE_SUCCESS'));
          }
          break;
        default:
          AlertService.showError(t('ERROR_SOMETHING_WENT_WRONG'));
          break;
      }

    }
    if (!error && !loading) {
      reset()
      onAdd()
    }
  }

  return (
    <>
      <DeleteModal
        display={openDeleteModal}
        setDisplay={setOpenDeleteModal}
        toDelete='User'
        onCloseModal={onAdd}
        endpoint={deleteModalEndpoint}
      />
      <div className='card'>
        <div className='card-header'>
          <h5 className="card-title fw-500">
            <strong>
              {t(`${selectedUser ? 'EDIT' : 'ADD'}`)} {t('USER')}
            </strong>
          </h5>
        </div>
        <div className='card-body'>
          <form
            onSubmit={handleSubmit(handleAddUser)}
            className='form-type-material'
          >
            <div className={`form-group ${values.firstName ? 'do-float' : ''}`}>
              <input
                type='text'
                className='form-control'
                name='firstName'
                id='firstName'
                onChange={handleInputChange}
                ref={register({ required: true })}
                value={values.firstName || ''}
              />
              <label htmlFor='firstName'>{t('FIRST_NAME')}</label>
            </div>
            <div className={`form-group ${values.lastName ? 'do-float' : ''}`}>
              <input
                type='text'
                className='form-control'
                name='lastName'
                id='lastName'
                onChange={handleInputChange}
                ref={register({ required: true })}
                value={values.lastName || ''}
              />
              <label htmlFor='lastName'>{t('LAST_NAME')}</label>
            </div>
            <div
              className={`form-group ${values.emailAddress ? 'do-float' : ''}`}
            >
              <input
                type='email'
                className='form-control'
                name='emailAddress'
                id='emailAddress'
                onChange={handleInputChange}
                ref={register({ required: true })}
                value={values.emailAddress || ''}
              />
              <label htmlFor='emailAddress'>{t('EMAIL_ADDRESS')}</label>
            </div>

            <div className='d-flex'>
              {selectedUser && (
                <i
                  role='button'
                  className='btn border-0 fa fa-trash'
                  onClick={handleUserDelete}
                ></i>
              )}

              <button
                className={`btn btn-bold d-block ml-auto btn-primary btn-label ${(!selectedUser && formState.isValid) ||
                  (selectedUser && formState.dirty)
                  ? ''
                  : 'disabled'
                  }`}
                type='submit'
              >
                <span>
                  <i className='ti-check'></i>
                </span>
                {selectedUser ? t('EDIT') : t('ADD')}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}

export default AddUserCard
